import React from "react";
import { Button, Modal, Typography } from "antd";
import AlertCircle from "@untitled-ui/icons-react/build/esm/AlertCircle";
import ReactDOM from "react-dom/client";

const { Title, Paragraph } = Typography;

// Checker Approval Modal Component
const CheckerApprovalModal = ({
  visible,
  onDetailsClick,
  onOkClick,
  onClose,
}) => {
  return (
    <Modal
      open={visible}
      footer={null}
      closable={false}
      centered
      width={500}
      bodyStyle={{ padding: 32 }}
      onCancel={onClose}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: 85,
            height: 85,
            borderRadius: "50%",
            backgroundColor: "#fff7e6",
            marginBottom: 5,
          }}
        >
          <AlertCircle
            style={{ fontSize: 24, width: 48, height: 48, color: "#fa8c16" }}
          />
        </div>

        <Title level={4} style={{ marginBottom: 8 }}>
          Waiting For Checker Approval
        </Title>

        <Paragraph style={{ color: "#666", fontSize: 14, marginBottom: 32 }}>
          The action has been created and is waiting for checker approval. Click
          on details to view the details of the created action.
        </Paragraph>

        <div
          style={{
            display: "flex",
            gap: 12,
            width: "100%",
          }}
        >
          <Button
            type="primary"
            className="of-primaryBtnColor"
            style={{
              height: 44,
              fontWeight: 600,
              width: "100%",
            }}
            onClick={onDetailsClick}
          >
            Details
          </Button>
        </div>
      </div>
    </Modal>
  );
};

// Singleton modal management
let checkerModalContainer = null;
let checkerModalRoot = null;

// Function to show checker approval modal
export const showCheckerApprovalModal = (onDetailsClick, onOkClick) => {
  try {
    // Close any existing modal
    if (checkerModalContainer) {
      checkerModalRoot?.unmount?.();
      checkerModalContainer.remove?.();
      checkerModalContainer = null;
      document.body.style.overflow = "";
    }

    // Create modal container
    checkerModalContainer = document.createElement("div");
    document.body.appendChild(checkerModalContainer);
    document.body.style.overflow = "hidden";

    checkerModalRoot = ReactDOM.createRoot(checkerModalContainer);

    const closeModal = () => {
      checkerModalRoot?.unmount?.();
      checkerModalContainer?.remove?.();
      checkerModalContainer = null;
      checkerModalRoot = null;
      document.body.style.overflow = "";
    };

    const handleDetailsClick = () => {
      if (onDetailsClick && typeof onDetailsClick === "function") {
        onDetailsClick();
      }
      closeModal();
    };

    const handleOkClick = () => {
      if (onOkClick && typeof onOkClick === "function") {
        onOkClick();
      }
      closeModal();
    };

    checkerModalRoot.render(
      <CheckerApprovalModal
        visible={true}
        onDetailsClick={handleDetailsClick}
        onOkClick={handleOkClick}
        onClose={closeModal}
      />,
    );
  } catch (error) {
    console.error("Checker modal error:", error);
    alert("The action has been created and is waiting for checker approval.");
  }
};

export default CheckerApprovalModal;
